"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateFileRequestToJSON = exports.CreateFileRequestFromJSONTyped = exports.CreateFileRequestFromJSON = exports.instanceOfCreateFileRequest = exports.CreateFileRequestMediaTypeEnum = void 0;
/**
 * @export
 */
exports.CreateFileRequestMediaTypeEnum = {
    AudioOgg: 'audio/ogg',
    AudioMp3: 'audio/mp3',
    AudioMpeg: 'audio/mpeg',
    AudioWav: 'audio/wav',
    AudioXWav: 'audio/x-wav',
    VideoMp4: 'video/mp4',
    VideoQuicktime: 'video/quicktime',
    ApplicationPdf: 'application/pdf',
    ImageJpeg: 'image/jpeg',
    ImageJpg: 'image/jpg',
    ImagePng: 'image/png'
};
/**
 * Check if a given object implements the CreateFileRequest interface.
 */
function instanceOfCreateFileRequest(value) {
    var isInstance = true;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "mediaType" in value;
    return isInstance;
}
exports.instanceOfCreateFileRequest = instanceOfCreateFileRequest;
function CreateFileRequestFromJSON(json) {
    return CreateFileRequestFromJSONTyped(json, false);
}
exports.CreateFileRequestFromJSON = CreateFileRequestFromJSON;
function CreateFileRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'name': json['name'],
        'mediaType': json['media_type'],
    };
}
exports.CreateFileRequestFromJSONTyped = CreateFileRequestFromJSONTyped;
function CreateFileRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'name': value.name,
        'media_type': value.mediaType,
    };
}
exports.CreateFileRequestToJSON = CreateFileRequestToJSON;
